module.exports = __webpack_public_path__ + "img/caiman-with-camera.6a9a0f4c.jpg";